import { useRecoilValue, useSetRecoilState } from "recoil";
import Router from "./Router";
import { createGlobalStyle } from "styled-components";
import { useCallback, useEffect, useState } from "react";
import { bigQueryAccessTokenState } from "./atom/atom";

import { getAccessToken } from "./module/bigQuery";
import { useCache } from "./hooks/useCache";
import { isAuthenticatedState } from "./atom/atom.auth";
import LoginPage from "./pages/LoginPage";
import ToastList from "./components/toast/ToastList";
import "./styles/tailwind.css";
import { GlobalStyle } from "./styles/GlobalStyle";

const EXPIRE_TIME = 12 * 60 * 60 * 1000;

function App() {
  const setBigQueryAccessToken = useSetRecoilState(bigQueryAccessTokenState);

  useCache();

  useEffect(() => {
    const fetchAccessToken = async () => {
      const accessToken = await getAccessToken();
      setBigQueryAccessToken(accessToken);
    };

    // fetchAccessToken();
  }, [setBigQueryAccessToken]);

  return (
    <>
      <GlobalStyle />
      <Router />
      <ToastList />
    </>
  );
}

export default App;
